import { render, staticRenderFns } from "./pictureBox.vue?vue&type=template&id=c04088da&scoped=true"
import script from "./pictureBox.vue?vue&type=script&lang=js"
export * from "./pictureBox.vue?vue&type=script&lang=js"
import style0 from "./pictureBox.vue?vue&type=style&index=0&id=c04088da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04088da",
  null
  
)

export default component.exports